import React from 'react';
import { Container } from 'semantic-ui-react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { toSnakeCase } from '../helpers/common';

const ImageAndCaption = (props) => {
  const { anchorTagLinkText, image, caption } = props;
  return (
    <section
      className="image-and-caption"
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container>
        <div className="grid-wrapper">
          <figure className="image-and-caption__figure">
            <GatsbyImage
              image={image?.localFile?.childImageSharp?.gatsbyImageData}
              tag="figure"
              className="image-and-caption__image"
              alt={image && image.altText ? image.altText : (caption ? caption : "no caption available")}
              backgroundColor="transparent"
            />
            {caption && (
              <figcaption className="image-and-caption__caption">
                {caption}
              </figcaption>
            )}
          </figure>
        </div>
      </Container>
    </section>
  );
};

export default ImageAndCaption;
